import React, {useEffect} from "react";
import styled from "@emotion/styled";

const PreloaderWrapper = styled.div<IProps>`
	width: 100%;
	height: 100%;
	display: flex;
	align-items: center;
	justify-content: center;
	position: fixed;
	top: 0;
	left: 0;
	background: ${(props) => (props.noBackground ? "transparent" : "rgba(0, 0, 0, 0.3)")};
	z-index: 999;
	overscroll-behavior: contain;
	overflow: scroll;
	pointer-events: none;
`;

const PreloaderContent = styled.div`
	display: inline-block;
	position: relative;
	width: 80px;
	height: 80px;

	@keyframes lds-ellipsis1 {
		0% {
			transform: scale(0);
		}
		100% {
			transform: scale(1);
		}
	}

	@keyframes lds-ellipsis3 {
		0% {
			transform: scale(1);
		}
		100% {
			transform: scale(0);
		}
	}

	@keyframes lds-ellipsis2 {
		0% {
			transform: translate(0, 0);
		}
		100% {
			transform: translate(24px, 0);
		}
	}

	div {
		position: absolute;
		top: 33px;
		width: 13px;
		height: 13px;
		border-radius: 50%;
		background: #fff;
		animation-timing-function: cubic-bezier(0, 1, 1, 0);

		&:nth-of-type(1) {
			left: 8px;
			animation: lds-ellipsis1 0.6s infinite;
		}

		&:nth-of-type(2) {
			left: 8px;
			animation: lds-ellipsis2 0.6s infinite;
		}

		&:nth-of-type(3) {
			left: 32px;
			animation: lds-ellipsis2 0.6s infinite;
		}

		&:nth-of-type(4) {
			left: 56px;
			animation: lds-ellipsis3 0.6s infinite;
		}
	}
`;

interface IProps {
	noBackground?: boolean;
}

export const Preloader: React.FC<IProps> = ({noBackground}) => {
	useEffect(() => {
		document.body.classList.add("disable_scroll");
		return () => {
			document.body.classList.remove("disable_scroll");
		};
	}, []);
	return (
		<PreloaderWrapper noBackground={noBackground}>
			<PreloaderContent>
				<div />
				<div />
				<div />
				<div />
			</PreloaderContent>
		</PreloaderWrapper>
	);
};

const Overlay = styled.div`
	position: fixed;
	left: 0;
	right: 0;
	top: 0;
	bottom: 0;
	width: 100%;
	height: 110%;
	background: rgba(255, 255, 255, 0.6);
	z-index: 29;
	pointer-events: all;
	overscroll-behavior: contain;
	overflow: scroll;
`;

export const PagePreloader: React.FC = () => {
	return (
		<Overlay aria-busy={true}>
			<Preloader />
		</Overlay>
	);
};
